import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { searchFeaturedListings, searchRecentListings } from '../LandingPage/LandingPage.duck';

export const loadData = (params, search, config) => dispatch => {
  const pageId = params.pageId;
  const pageAsset = { [pageId]: `content/pages/${pageId}.json` };
  const hasFallbackContent = false;
  const promises = [
    dispatch(fetchPageAssets(pageAsset, hasFallbackContent)),
  ];
  if (params.pageId === 'nl-home') {
    promises.push(
      dispatch(searchFeaturedListings(config)),
      dispatch(searchRecentListings(config))
    );
  }
  // Fetch common listing carousels in parallel so CMS pages have data without component-side effects
  return Promise.all(promises);
};
